import { Link } from "react-router-dom";
import Crest from "../components/Crest";
import Seo from "../components/Seo";

function NotFoundPage() {
  return (
    <div className="status-page">
      <Seo
        description="The page you're looking for doesn't exist or may have been moved."
        noindex
        path="/404"
        title="Page Not Found - Robert Doe"
      />
      <Crest className="status-page-crest" />
      <div className="status-page-code">404</div>
      <h1 className="status-page-title">Page Not Found</h1>
      <p className="status-page-note">
        The page you&apos;re looking for doesn&apos;t exist or may have been moved.
      </p>
      <Link className="btn-primary" to="/">
        Back to Portfolio
      </Link>
    </div>
  );
}

export default NotFoundPage;
